<i18n>
{
  "fr": {
    "titleTrip": "LE VOYAGE",
    "outbound": "Traversée Aller",
    "return": "Traversée Retour",
    "cabins": "Cabine(s) intérieure(s)",
    "cabins-ext": "Cabine(s) extérieure(s)",
    "comment": "4 personnes maximum par cabine",
    "seats": "Fauteuil(s)",
    "required": "Champs requis"
  },
  "en": {
    "titleTrip": "THE TRIP",
    "outbound": "Outbound Crossing",
    "return": "Return Crossing",
    "cabins": "Cabins",
    "comment": "Maximum 4 people per cabin",
    "seats": "Seats",
    "required": "Required"
  }
}
</i18n>

<template>
  <v-container>
    <h2
      class="title-container"
    >
      {{ $t('titleTrip') }}
    </h2>
    <v-row>
      <v-col
        cols="10"
        md="5"
        class="pb-0"
      >
        <label
          class="title-input"
          for="traverseeAller"
        >
          {{ $t('outbound') }}
        </label>
        <v-select
          v-model="selectedTravelGo"
          :items="travelGo"
          class="my-0 outward py-0"
          color="primary"
          background-color="primaryLight"
          solo
          flat
          hide-details
          required
          clearable
          :rules="[value => !!value || 'Champs requis']"
          item-text="label"
        />
        <span
          v-if="!selectedTravelGo && formNotValidate"
          class="error-message"
        >
          {{ $t('required') }}
        </span>
      </v-col>
      <v-col
        cols="10"
        md="5"
        class="pb-0"
      >
        <label
          class="title-input"
          for="traverseeRetour"
        >
          {{ $t('return') }}
        </label>
        <v-select
          v-model="selectedTravelBack"
          :items="travelBack"
          class="my-0 outward py-0"
          color="primary"
          background-color="primaryLight"
          solo
          flat
          hide-details
          required
          clearable
          :rules="[value => !!value || 'Champs requis']"
          item-text="label"
        />
        <span
          v-if="!selectedTravelBack && formNotValidate"
          class="error-message"
        >
          {{ $t('required') }}
        </span>
      </v-col>
    </v-row>
    <v-row class="mt-3">
      <v-col
        cols="10"
        md="3"
        class="pb-0"
      >
        <label
          class="title-input"
          for="cabines"
        >
          {{ $t('cabins') }}
        </label>
        <v-select
          id="cabines"
          v-model="selectedCabin"
          :items="cabins"
          class="my-0 outward py-0"
          color="primary"
          background-color="primaryLight"
          solo
          flat
          hide-details
          required
          :rules="[value => !!value || 'Champs requis']"
          @change="changeCab"
        />
        <span
          v-if="!selectedCabin && formNotValidate"
          class="error-message"
        >
          {{ $t('required') }}
        </span>
        <p
          class="comment-input"
        >
          {{ $t('comment') }}
        </p>
      </v-col>
      <v-col
        cols="10"
        md="3"
        class="pb-0"
      >
        <label
          class="title-input"
          for="cabines"
        >
          {{ $t('cabins-ext') }}
        </label>
        <v-select
          id="cabines"
          v-model="selectedCabinExt"
          :items="cabins"
          class="my-0 outward py-0"
          color="primary"
          background-color="primaryLight"
          solo
          flat
          hide-details
          required
          :rules="[value => !!value || 'Champs requis']"
          @change="changeCab"
        />
        <span
          v-if="!selectedCabinExt && formNotValidate"
          class="error-message"
        >
          {{ $t('required') }}
        </span>
        <p
          class="comment-input"
        >
          {{ $t('comment') }}
        </p>
      </v-col>
      <v-col
        cols="10"
        md="3"
        class="pb-0"
      >
        <label
          class="title-input"
          for="fauteuils"
        >
          {{ $t('seats') }}
        </label>
        <v-select
          id="fauteuils"
          v-model="selectedChair"
          :items="chairs"
          class="my-0 outward py-0"
          color="primary"
          background-color="primaryLight"
          solo
          flat
          hide-details
          required
          :rules="[value => !!value || 'Champs requis']"
          @change="changeCab"
        />
        <span
          v-if="!selectedChair && formNotValidate"
          class="error-message"
        >
          {{ $t('required') }}
        </span>
      </v-col>
    </v-row>
    <FerryOutwardDatePicker
      ref="ferryPicker"
      :form-not-validate="formNotValidate"
    />
  </v-container>
</template>

<script>

import FerryOutwardDatePicker from './FerryDatePicker.vue'

export default {
  components: {
    FerryOutwardDatePicker
  },
  props: {
    formNotValidate: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    travelGo: [],
    selectedTravelGo: '',
    travelBack: [],
    selectedTravelBack: '',
    cabins: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
    selectedCabin: '',
    selectedCabinExt: '',
    chairs: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
    selectedChair: '',
    outwardDate: '',
    returnDate: ''
  }),
  mounted () {
    const destinationsGoCorse = ['Marseille - Ajaccio', 'Marseille - Bastia', 'Marseille - Ile Rousse', 'Marseille - Porto Vecchio', 'Marseille - Porto Propriano',
      'Nice - Bastia', 'Toulon - Ajaccio', 'Toulon - Bastia', 'Toulon - Ile Rousse', 'Toulon - Porto-Vecchio', 'Gênes - Bastia', 'Livourne - Bastia', 'Livourne - Ile Rousse',
      'Savone - Bastia', 'Savone - Ile Rousse']
    const destinationsGoSardaigneContinent = ['Livourne - Golfo Aranci', 'Nice - Golfo Aranci', 'Savone - Golfo Aranci', 'Toulon - Porto Torres']
    const destinationsGoSardaigneCorse = ['Ajaccio - Porto Torres', 'Bonifacio - Santa Teresa']
    const destinationsGoSicile = ['Livourne - Palerme', 'Salerne - Palerme', 'Naples - Palerme', 'Cagliari - Palerme']
    const destinationsGoBaleares = ['Toulon - Alcudia', 'Toulon - Minorque', 'Barcelone - Ibiza', 'Barcelone - Majorque', 'Barcelone - Minorque (Ciutadella)',
      'Barcelone - Minorque (Mahon)', 'Barcelone - Formentera', 'Dénia - Ibiza', 'Dénia - Mallorca', 'Dénia - Formentera', 'Formentera - Ibiza']
    const destinationsGoGrece = ['Ancône - Patras', 'Ancône - Igoumenitsa', 'Brindisi - Corfou', 'Brindisi - Igoumenitsa', 'Brindisi - Patras', 'Ancône - Corfou']

    const destinationsBackCorse = ['Bastia - Nice', 'Bastia - Livourne', 'Ajaccio - Toulon', 'Bastia - Savone', 'Ile Rousse - Toulon', 'Bastia - Toulon', 'Ajaccio - Marseille',
      'Bastia - Marseille', 'Ile Rousse - Marseille', 'Porto Vecchio - Marseille', 'Propriano - Marseille']
    const destinationsBackSardaigne = ['Golfo Aranci - Livourne', 'Golfo Aranci - Nice', 'Porto Torres - Toulon']
    const destinationsBackSicile = ['Trapani - Toulon', 'Palerme - Livourne', 'Palerme - Salerne']
    const destinationsBackBaleares = ['Alcudia - Toulon', 'Minorque (Ciutadella) - Barcelone', 'Minorque (Mahon) - Barcelone', 'Minorque - Toulon', 'Ibiza - Barcelone',
      'Ibiza - Dénia', 'Ibiza - Mallorca', 'Ibiza - Formentera', 'Formentera - Ibiza', 'Formentera - Dénia', 'Formentara - Mallorca', 'Mallorca - Barcelone', 'Mallorca - Ibiza',
      'Mallorca - Menorca', 'Mallorca - Dénia']
    const destinationsBackGrece = ['Patras - Ancône', 'Igoumenitsa - Ancône', 'Corfou - Brindisi', 'Igoumenitsa - Brindisi', 'Patras - Brindisi', 'Corfou - Ancône']

    this.travelGo.push({ header: 'Corse' })
    destinationsGoCorse.forEach(item => {
      this.travelGo.push({ label: item })
    })
    this.travelGo.push({ header: 'Sardaigne depuis le continent' })
    destinationsGoSardaigneContinent.forEach(item => {
      this.travelGo.push({ label: item })
    })
    this.travelGo.push({ header: 'Sardaigne depuis la Corse' })
    destinationsGoSardaigneCorse.forEach(item => {
      this.travelGo.push({ label: item })
    })
    this.travelGo.push({ header: 'Sicile' })
    destinationsGoSicile.forEach(item => {
      this.travelGo.push({ label: item })
    })
    this.travelGo.push({ header: 'Ile d\'Elbe' })
    this.travelGo.push({ label: 'Piombino - Portoferraio' })
    this.travelGo.push({ header: 'Baléares' })
    destinationsGoBaleares.forEach(item => {
      this.travelGo.push({ label: item })
    })
    this.travelGo.push({ header: 'Grèce' })
    destinationsGoGrece.forEach(item => {
      this.travelGo.push({ label: item })
    })

    this.travelBack.push({ header: 'Corse' })
    destinationsBackCorse.forEach(item => {
      this.travelBack.push({ label: item })
    })
    this.travelBack.push({ header: 'Sardaigne' })
    destinationsBackSardaigne.forEach(item => {
      this.travelBack.push({ label: item })
    })
    this.travelBack.push({ header: 'Sicile' })
    destinationsBackSicile.forEach(item => {
      this.travelBack.push({ label: item })
    })
    this.travelBack.push({ header: 'Ile d\'Elbe' })
    this.travelBack.push({ label: 'Piombino - Portoferraio' })
    this.travelBack.push({ header: 'Baléares' })
    destinationsBackBaleares.forEach(item => {
      this.travelBack.push({ label: item })
    })
    this.travelBack.push({ header: 'Grèce' })
    destinationsBackGrece.forEach(item => {
      this.travelBack.push({ label: item })
    })
  },
  methods: {
    changeCab () {
      if (this.selectedCabin !== '' && this.selectedCabin !== '0') {
        if (this.selectedCabinExt === '') {
          this.selectedCabinExt = '0'
        }
        if (this.selectedChair === '') {
          this.selectedChair = '0'
        }
      }
      if (this.selectedCabinExt !== '' && this.selectedCabinExt !== '0') {
        if (this.selectedCabin === '') {
          this.selectedCabin = '0'
        }
        if (this.selectedChair === '') {
          this.selectedChair = '0'
        }
      }
      if (this.selectedChair !== '' && this.selectedChair !== '0') {
        if (this.selectedCabinExt === '') {
          this.selectedCabinExt = '0'
        }
        if (this.selectedCabin === '') {
          this.selectedCabin = '0'
        }
      }
    },
    validateTravelForm () {
      if (this.$refs.ferryPicker.validateDateForm() === 1) {
        const ferryPicker = this.$refs.ferryPicker
        return {
          outwardTravel: this.selectedTravelGo,
          returnTravel: this.selectedTravelBack,
          cabins: this.selectedCabin,
          cabinsExt: this.selectedCabinExt,
          chairs: this.selectedChair,
          outwardDate: ferryPicker.outwardDate,
          returnDate: ferryPicker.returnDate
        }
      } else {
        return 84
      }
    }
  }
}
</script>

<style scoped>
.comment-input {
  opacity: 0.35;
  margin-top: 7px;
  margin-bottom: 7px;
  font-size: 13px;
}

.error-message {
  color: red;
  font-size: 14px;
  font-style: italic;
}

.title-container {
  margin-bottom: 17px;
  font-weight: 800;
  color: #006fb9;
}

.title-input {
  color: #006fb9;
  font-size: 18px;
  font-weight: 550;
  opacity: 0.8;
}

</style>
